import React from 'react';
import cn from 'classnames';
import { Icon } from '@economic/taco';

interface Props {
    functionality: { id: string; name: string };
    index: number;
    isAvailable: boolean;
}
export default function PackageCardFuctionality({ functionality, index, isAvailable }: Props) {
    return (
        <div key={functionality.id} className={cn('flex items-center', index > 0 ? 'pt-3' : '')}>
            <Icon
                name={isAvailable ? 'tick' : 'line'}
                className={cn('bg-transparent', isAvailable ? 'text-green' : 'text-red')}
            />
            <span className={!isAvailable ? 'text-grey-500' : ''}>{functionality.name}</span>
        </div>
    );
}
